import React, { useState, useEffect } from 'react';
import Button from '../components/Button';
import loginImage from '../assets/images/login.svg';
import logo from '../assets/images/logo.svg';
import '../styles/login.css';
import { loginUser } from '../api/api';
import { useDispatch } from 'react-redux';
import { loginSuccess } from '../features/auth/AuthSlice';
import { useNavigate } from 'react-router-dom';
import Toastmessage from '../components/Toast';
import { Link } from 'react-router-dom';
import { authApi } from '../api/api';
import { useLocation } from "react-router-dom";

const ResetPassword = () => {


  const location = useLocation();

  // Parse the query string
  const params = new URLSearchParams(location.search);
  const val = params.get("val");

  // State management
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [errors, setErrors] = useState({email:'', password:''});
  const [isLoading, setIsloading] = useState(false); 
  const dispatch = useDispatch();
  const navigate = useNavigate();


  // Extract email from URL on component mount
  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search); // Get URL params
    const emailFromUrl = queryParams.get('email'); // Extract "email" param
    if (emailFromUrl) {
      setEmail(emailFromUrl); // Set email state
    }
  }, []);


  // Validation email and password
  const validateEmail = (email) => {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return regex.test(email);
  }

  const validatePassword = (password) => {
    return password.length >= 5;
  }


  const loginValidate = async () => {
    let emailError = '';
    let passwordError = '';
    let confirmPasswordError = '';
  
    if (!validatePassword(password)) {
      passwordError = 'Password must be at least 6 characters long.';
    }
  
    if (password !== confirmPassword) {
      confirmPasswordError = 'Password and Confirm Password do not match.';
    }
  
    if (emailError || passwordError || confirmPasswordError) {
      setErrors({
        email: emailError,
        password: passwordError,
        confirmPassword: confirmPasswordError,
      });
    } else {
      setErrors({ email: '', password: '', confirmPassword: '' });
      setIsloading(true); // Start loading
  
      const addPasswordResetCall = async () => {
        const input_token = val + 'RESET'; // Replace with your actual token
        const apiUrl = 'reset_client_password'; // Replace with the actual API endpoint
  
        const dataInput = {
          val: val,
          password: password,
        };
  
        try {
          const data = await authApi(input_token, dataInput, apiUrl, '');
  
          if (data && data.success) {
            await Toastmessage(data.message, true);
            navigate('/');
          } else if (data && data.message === 'Token has expired') {
            await Toastmessage('Session expired. Redirecting to login...', false);
            navigate('/login');
          } else if (data === undefined) {
            await Toastmessage('No response from server', false);
          } else {
            await Toastmessage(data?.message || 'An error occurred', false);
          }
  
        } catch (error) {
          console.error("Error fetching data:", error);
          if (error.response && error.response.status === 401) {
            await Toastmessage('Session expired. Redirecting to login...', false);
            navigate('/login');
          } else {
            await Toastmessage('Something went wrong', false);
          }
        }
      }
      addPasswordResetCall();
    }
  };
  

  return (
    <div>
      <div className="content">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-md-6 d-none d-md-block">
              <img src={loginImage} alt="Image" className="img-fluid p-3" />
            </div>
            <div className="col-md-6 contents">
              <div className="row justify-content-center">
                <div className="col-md-9">
                  <div className="mb-4">
                    <img src={logo} alt="company logo" className='img-fluid p-3 d-block mx-auto'/>
                    <h3>Reset Password</h3>
                  
                  </div>
                  <div>
                    {/* <div className={`form-group first ${email ? 'field--not-empty' : ''}`}>
                        <label htmlFor="email">Email ID</label>
                        <input
                        type="email"
                        className="form-control"
                        id="email"
                        value={email}
                        disabled // Make input field disabled
                        />
                    </div> */}
                    {errors.email && <div className="text-danger small">{errors.email}</div>}

                    <div className={`form-group last mt-4 ${password ? 'field--not-empty' : ''}`}>
                        <label htmlFor="password">Password</label>
                        <input
                        type="password"
                        className="form-control"
                        id="password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)} // Update password state
                        />
                    </div>
                    {errors.password && <div className="text-danger small">{errors.password}</div>}

                    <div className={`form-group last mt-4 ${confirmPassword ? 'field--not-empty' : ''}`}>
                        <label htmlFor="confirmPassword">Confirm Password</label>
                        <input
                        type="password"
                        className="form-control"
                        id="confirmPassword"
                        value={confirmPassword}
                        onChange={(e) => setConfirmPassword(e.target.value)} // Update confirmPassword state
                        />
                    </div>
                    {errors.confirmPassword && <div className="text-danger small">{errors.confirmPassword}</div>}

                    <Button
                        label="Submit"
                        onClick={loginValidate}
                        customClass="btn-button-padding btn-block btn-theme-button mt-4 mb-3"
                        disabled={isLoading}
                    />
                    <Link className='text-center d-block' to='/'>Goto Login page</Link>
                    </div>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;
